import React, { useState, useEffect } from 'react';
import { string } from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from '../../util/reactIntl';
import { fetchDealers } from '../../util/api';
import { FieldSelect } from '../../components';
import * as validators from '../../util/validators';

import css from './DealerSelectionField.module.css';

const DealerSelectionField = props => {
  const { className, name, id, intl } = props;
  const [dealers, setDealers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchDealers()
      .then(response => {
        setDealers(response.dealers || []);
        setLoading(false);
      })
      .catch(err => {
        console.error('Failed to fetch dealers:', err);
        setError(err.message);
        setLoading(false);
      });
  }, []);

  const classes = classNames(css.root, className);

  if (loading) {
    return (
      <div className={classes}>
        <FormattedMessage id="DealerSelectionField.loading" />
      </div>
    );
  }

  if (error) {
    return (
      <div className={classNames(classes, css.error)}>
        <FormattedMessage id="DealerSelectionField.fetchError" />
      </div>
    );
  }

  // If no dealers available, show helpful message instead of empty required dropdown
  if (dealers.length === 0) {
    return (
      <div className={classNames(classes, css.noDealers)}>
        <p className={css.noDealersMessage}>
          <FormattedMessage id="DealerSelectionField.noDealersAvailable" />
        </p>
      </div>
    );
  }

  return (
    <div className={classes}>
      <FieldSelect
        id={id}
        name={name}
        className={css.select}
        label={intl.formatMessage({
          id: 'DealerSelectionField.label',
        })}
        validate={validators.required(
          intl.formatMessage({
            id: 'DealerSelectionField.required',
          })
        )}
      >
        <option value="">{intl.formatMessage({ id: 'DealerSelectionField.placeholder' })}</option>
        {dealers.map(dealer => {
          // Extract location from publicData if it exists
          // businessLocation might be an object or a string
          let location = '';
          if (dealer.publicData?.businessLocation) {
            if (typeof dealer.publicData.businessLocation === 'string') {
              location = dealer.publicData.businessLocation;
            } else if (dealer.publicData.businessLocation.address) {
              location = dealer.publicData.businessLocation.address;
            }
          }

          return (
            <option key={dealer.id} value={dealer.id}>
              {dealer.displayName}
              {location ? ` - ${location}` : ''}
            </option>
          );
        })}
      </FieldSelect>

      <p className={css.helpText}>
        <FormattedMessage id="DealerSelectionField.helpText" />
      </p>
    </div>
  );
};

DealerSelectionField.defaultProps = {
  className: null,
};

DealerSelectionField.propTypes = {
  className: string,
  name: string.isRequired,
  id: string.isRequired,
};

export default DealerSelectionField;
